<template>
    <div class="modal fade" id="selectCalendarModelsModal" role="dialog" aria-labelledby="selectionLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="selectionLabel">{{ $t('organizationalModel.titles') }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="loader" v-if="loading"></div>
                <div class="modal-body">
                    <div class="table-responsive">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th scope="col"></th>
                                    <!--<th scope="col">{{ $t('organizationalModel.gridHeaders.id')}}</th>-->
                                    <th scope="col">{{ $t('organizationalModel.gridHeaders.name')}}</th>
                                    <th scope="col">{{ $t('organizationalModel.gridHeaders.nameEn')}}</th>
                                    <th scope="col">{{ $t('organizationalModel.gridHeaders.description')}}</th>
                                    <th scope="col">{{ $t('organizationalModel.gridHeaders.eventForms')}}</th>
                                    <th scope="col">{{ $t('organizationalModel.gridHeaders.eventActivities')}}</th>
                                    <th scope="col">{{ $t('organizationalModel.gridHeaders.loaded')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="m in calendarModels"
                                    :key="m.id">
                                    <td>
                                        <vs-checkbox v-model="m.checked">
                                        </vs-checkbox>
                                    </td>
                                    <!--<th>{{m.id}}</th>-->
                                    <td>{{m.name}}</td>
                                    <td>{{m.nameEn}}</td>
                                    <td>{{m.description}}</td>
                                    <td>{{m.eventForms}}</td>
                                    <td>{{m.eventActivities}}</td>
                                    <td><span :class="m.loaded ? 'badge badge-success' : 'badge badge-light'">{{ m.loaded ? $t('yes') : $t('no') }}</span></td>
                                </tr>

                            </tbody>
                        </table>
                    </div>

                    <div v-if="organizationalCalendarSettings" class="mt-3">
                        <hr />
                        <h6>{{ $t('organizationalCalendarSettings.title')}}</h6>
                        <p v-if="!overrideOrganizationalCalendarSettings">{{ organizationalCalendarSettings }}</p>

                        <div class="form-group">
                            <vs-checkbox v-model="overrideOrganizationalCalendarSettings"
                                         :name="'overrideOrganizationalCalendarSettings' + _uid"
                                         :id="'overrideOrganizationalCalendarSettings' + _uid"
                                         style="justify-content: flex-start !important"
                                         aria-describedby="overrideOrganizationalCalendarSettingsHelp">
                                {{ $t('organizationalCalendarSettings.override') }}
                            </vs-checkbox>
                            <small id="overrideOrganizationalCalendarSettingsHelp" class="form-text text-muted">
                                {{$t('organizationalCalendarSettings.help.override')}}
                            </small>
                        </div>

                        <div v-if="customOrganizationalCalendarSettings !== null" class="row">
                            <div class="form-group col-md-6 col-sm-12">
                                <vs-checkbox v-model="customOrganizationalCalendarSettings.loadOnlyValidModels"
                                             :name="'loadOnlyValidModels' + _uid"
                                             :id="'loadOnlyValidModels' + _uid"
                                             style="justify-content: flex-start !important"
                                             aria-describedby="loadOnlyValidModelsHelp">
                                    {{ $t('organizationalCalendarSettings.loadOnlyValidModels') }}
                                </vs-checkbox>
                                <small id="loadOnlyValidModelsHelp" class="form-text text-muted">
                                    {{$t('organizationalCalendarSettings.help.loadOnlyValidModels')}}
                                </small>
                            </div>
                            <div class="form-group col-md-6 col-sm-12">
                                <vs-checkbox v-model="customOrganizationalCalendarSettings.calendarModelsANDFilter"
                                             :name="'calendarModelsANDFilter' + _uid"
                                             :id="'calendarModelsANDFilter' + _uid"
                                             style="justify-content: flex-start !important"
                                             aria-describedby="calendarModelsANDFilterHelp">
                                    {{ $t('organizationalCalendarSettings.calendarModelsANDFilter') }}
                                </vs-checkbox>
                                <small id="calendarModelsANDFilterHelp" class="form-text text-muted">
                                    {{$t('organizationalCalendarSettings.help.calendarModelsANDFilter')}}
                                </small>
                            </div>
                            <div class="form-group col-sm-12 col-md-12">
                                <button type="button" class="btn btn-primary" :disabled="loading" @click.stop="loadOrgModels">{{$t('buttons.reload.btnText')}}</button>
                            </div>
                        </div>

                    </div>

                </div>
                <div class="modal-footer" v-show="!loadingModels && !isLockedForEdit">
                    <button type="button" class="btn btn-primary" :disabled="!hasChecked" @click.stop="loadModelsToCalendar">{{$t('buttons.load.btnText')}}</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">{{$t('buttons.cancel')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { OrganizationalModel, OrganizationalCalendarSettings } from '../../models/models';
    import orgModelService from '../../services/orgModel.service';

    export default {
        components: {

        },
        props: {
            eventId: {
                type: Number,
                required: true,
            },
            show: {
                type: Boolean,
                default: false
            },
            isLockedForEdit: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                calendarModels: [],
                loading: false,
                loadingModels: false,
                organizationalCalendarSettings: null,
                overrideOrganizationalCalendarSettings: false,
                customOrganizationalCalendarSettings: null
            };
        },
        methods: {
            loadOrganizationalCalendarSettings() {
                orgModelService
                    .getOrganizationalCalendarSettings()
                    .then(response => {
                        if (response && response.data) {
                            this.organizationalCalendarSettings = new OrganizationalCalendarSettings(response.data);
                        }
                    })
                    .catch(error => {
                       // Todo:
                    });
            },
            loadOrgModels() {
                this.loading = true;
                this.calendarModels = [];

                orgModelService
                    .getValidModels(this.eventId, this.overrideOrganizationalCalendarSettings, this.customOrganizationalCalendarSettings)
                    .then(response => {
                        this.loading = false;

                        if (response.data && Array.isArray(response.data)) {
                            response.data.forEach(m => {
                                this.calendarModels.push(new OrganizationalModel(m));
                            });
                        }
                    })
                    .catch(error => {
                        this.loading = false;

                        let statusCode = this.$helpers.errorStatusCode(error);
                        if (statusCode === 403) {
                            this.accessDenied();
                            return;
                        }

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    });
            },
            loadModelsToCalendar() {
                this.isLoadind = true;
                let model = { eventId: this.eventId, calendarModels: this.checkedModels };
                this.$http.post(`/api/organizationalCalendar/createOrUpdate/`, model).then((response => {
                    this.isLoadind = false;
                    this.$emit('loaded');

                })).catch(error => {
                    this.isLoadind = false;

                    let statusCode = this.$helpers.errorStatusCode(error);
                    if (statusCode === 403) {
                        this.accessDenied();
                        return;
                    }

                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: this.$helpers.errorColor(error),
                        time: this.$store.getters.notificationDuration
                    });
                });
            },
            onClose() {
                this.$emit('onClose');
                this.isLoadind = false;
                this.$validator.reset();
            },
            hide() {
                $(this.$el).modal('hide');
            }
        },
        mounted() {
            //add modal close listener
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            //remove listener
            $(this.$el).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.loadOrgModels();
                    this.loadOrganizationalCalendarSettings();
                    $(this.$el).modal('show');
                } else {
                    $(this.$el).modal('hide');
                }
            },
            overrideOrganizationalCalendarSettings: function (val) {
                if (val) {
                    this.customOrganizationalCalendarSettings = this.organizationalCalendarSettings ? new OrganizationalCalendarSettings(this.organizationalCalendarSettings) : new OrganizationalCalendarSettings();
                } else {
                    this.customOrganizationalCalendarSettings = null;
                    this.loadOrgModels();
                }
            }
        },
        computed: {
            checkedModels() {
                var data = this.calendarModels.filter((row) => {
                    return row.checked;
                });

                return data;
            },
            hasChecked() {
                return Array.isArray(this.checkedModels) && this.checkedModels.length > 0;
            }
        }
    };
</script>

<style scoped>
</style>

